import { RISK_ASSESSMENT } from './riskAssessment.action.ts';

const GET_RISK_ASSESSMENT_MANAGEMENT = `${RISK_ASSESSMENT}/GET_RISK_ASSESSMENT_MANAGEMENT`;
const POST_RISK_ASSESSMENT_MANAGEMENT = `${RISK_ASSESSMENT}/POST_RISK_ASSESSMENT_MANAGEMENT`;
const DELETE_RISK_ASSESSMENT_MANAGEMENT = `${RISK_ASSESSMENT}/DELETE_RISK_ASSESSMENT_MANAGEMENT`;
const GET_RISK_ASSESSMENT_MANAGEMENT_DETAIL = `${RISK_ASSESSMENT}/GET_RISK_ASSESSMENT_MANAGEMENT_DETAIL`;
const GET_RISK_ASSESSMENT_MANAGEMENT_ATTACHMENTS = `${RISK_ASSESSMENT}/GET_RISK_ASSESSMENT_MANAGEMENT_ATTACHMENTS`;
const DOWNLOAD_RISK_ASSESSMENT_MANAGEMENT_ATTACHMENT = `${RISK_ASSESSMENT}/DOWNLOAD_RISK_ASSESSMENT_MANAGEMENT_ATTACHMENT`;
export const RamActions = {
  GET_RISK_ASSESSMENT_MANAGEMENT,
  POST_RISK_ASSESSMENT_MANAGEMENT,
  DELETE_RISK_ASSESSMENT_MANAGEMENT,
  GET_RISK_ASSESSMENT_MANAGEMENT_DETAIL,
  GET_RISK_ASSESSMENT_MANAGEMENT_ATTACHMENTS,
  DOWNLOAD_RISK_ASSESSMENT_MANAGEMENT_ATTACHMENT
};
